import React from "react";
import "../../../assets/styles/common/listCard.scss";

import { SummaryData } from "../../../hooks/useSummary";
import { ResultPagesData } from "../../../hooks/useResultPages";

interface SummaryListsProps {
  summaries: SummaryData[];
  resultPages: ResultPagesData[];
  onEdit: (year: string) => void;
}

const SummaryLists: React.FC<SummaryListsProps> = ({
  summaries,
  resultPages,
  onEdit,
}) => {

  // 作成済みリザルトページの年度一覧
  const createdYears = new Set(resultPages.map((page) => page.id));

  // 場所の表示
  const getVenues = (summary: SummaryData) => {
    const venues = [
      summary.quartetSemiFinalVenue,
      summary.quartetFinalVenue,
      summary.chorusFinalVenue,
      summary.evaluationOnlyVenue,
    ].filter(Boolean);

    return [...new Set(venues)].join(", ");
  };

  // 日付の表示
  const getEventDateRange = (summary: SummaryData) => {
    const dates = [
      summary.quartetSemiFinalAt,
      summary.quartetFinalAt,
      summary.chorusFinalAt,
      summary.evaluationOnlyAt,
    ]
      .filter(Boolean)
      .map((date) => date.toDate())
      .sort((a, b) => a.getTime() - b.getTime());

    if (dates.length === 0) {
      return "";
    }

    const start = dates[0];
    const end = dates[dates.length - 1];

    const format = (date: Date) => `${date.getMonth() + 1}/${date.getDate()}`;

    return start.getTime() === end.getTime()
      ? format(start)
      : `${format(start)} ~ ${format(end)}`;
  };

  return (
    <div className="table-contents">
      <div className="table-main">
        {summaries.length === 0 ? (
          <p style={{ padding: "20px" }}>データが登録されていません。</p>
        ) : (
          summaries.map((summary) => {
            const isCreated = createdYears.has(summary.id);

            const resultPage = resultPages.find(
              (page) => page.id === summary.id,
            );

            const hasUnpublishedPages =
              isCreated &&
              resultPage &&
              Object.values(resultPage.pages).some((page) => !page.published);

            return (
              <section className="card-list" key={summary.id}>
                <article className="list-card summary">
                  <div className="flex-space-between">
                    <div className="flex-align-center">
                      <h2>{summary.id}年</h2>
                      <p className="summary-text">
                        {getEventDateRange(summary)}
                      </p>
                      <p className="summary-text">{getVenues(summary)}</p>
                    </div>
                    <div>
                      <p className="updated-at">
                        {summary.updatedAt
                          ? summary.updatedAt
                              .toDate()
                              .toLocaleDateString("ja-JP")
                          : "未設定"}
                      </p>

                      <div className="list-edit">
                        <button
                          className="editbtn"
                          onClick={() => onEdit(summary.id)}
                        >
                          詳細
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="judge-area">
                    <div className="judge-panel">
                      <h3>judge Panel</h3>
                      <div>
                        <p>
                          <span>ADM：</span>
                          {summary.judgePanelADM}
                        </p>
                        <p>
                          <span>MUS：</span>
                          {summary.judgePanelMUS}
                        </p>
                        <p>
                          <span>PER：</span>
                          {summary.judgePanelPER}
                        </p>
                        <p>
                          <span>SNG：</span>
                          {summary.judgePanelSNG}
                        </p>
                      </div>
                    </div>
                  </div>
                </article>
              </section>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SummaryLists;
